import fiscalInstance from '../../instance'

const createTestReport = () => {
	return fiscalInstance.post('/cashRegisterClose/reports/test')
}

export default createTestReport
